import reqwest from 'reqwest';

/* Responsibility: Untangle FINN.travel code from any specific ajax library
 *
 * Note: The callback follows the Node.JS way of async error handling,
 *       ie. the error object is passed as the first argument to the callback.
 *
 *       This way you are forced to think about error cases when handling a result
 *       that goes over the network.
 *
 *       Ref. http://en.wikipedia.org/wiki/Fallacies_of_Distributed_Computing
 */

let increment = new Date().getTime();

export default {
    load(params) {
        if (params.url.includes('flybilletter')) {
            if (typeof params.data === 'undefined') {
                params.data = [{ name: 'cacheBuster', value: increment }];
            } else {
                params.data.push({ name: 'cacheBuster', value: increment });
            }
            increment += 1;
        }

        return reqwest({
            url: params.url,
            type: params.dataType,
            method: params.method,
            data: params.data,
            crossOrigin: params.crossOrigin || false,
            success(data) {
                if (!params.callback) {
                    return;
                }
                params.callback(null, data);
            },
            error(data) {
                if (!params.callback) {
                    return;
                }
                params.callback(data);
            },
        });
    },
};
